import React, { ReactNode } from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { Icon } from '../../Icon';
import { Text } from '../../Text';
export type ControlType = 'radio' | 'checkbox';
interface Props {
  /** Pass through className to allow styles overrides */
  className?: string;
  /** Identify the element for selection in integration tests, FullStory, etc. */
  dataId?: string;
  /** Whether the control is checked or not */
  checked: boolean;
  /** Whether the control is disabled or not */
  disabled?: boolean;
  /** Whether the control container should render full width */
  fullWidth?: boolean;
  /** Whether the input has an error */
  hasError?: boolean;
  /** Content to render in label next to the control */
  label?: ReactNode;
  /** Name used for html input element */
  name: string;
  /** The control change handler. Fires when user change state of the Control (radio or checkbox) */
  onChange?: (e: React.SyntheticEvent) => void;
  /** Value used for html input element */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value?: any;
  /** Use larger touch area */
  hasTouchArea?: boolean;
  /** Whether the type is radio or checkbox */
  type: ControlType;
}
const ControlElement = /*#__PURE__*/styled('div')({
  name: "ControlElement",
  class: "c1vck8sd",
  propsAsIs: false
});
const _exp = /*#__PURE__*/() => ({
  hasTouchArea
}) => hasTouchArea ? 12 : 2;
const _exp2 = /*#__PURE__*/() => ({
  fullWidth
}) => fullWidth ? '1' : 'initial';
export const ControlBody = /*#__PURE__*/styled('label')({
  name: "ControlBody",
  class: "c1ry4ywi",
  propsAsIs: false,
  vars: {
    "c1ry4ywi-0": [_exp(), "px"],
    "c1ry4ywi-1": [_exp2()]
  }
});
export const RadioContentWrapper = /*#__PURE__*/styled('div')({
  name: "RadioContentWrapper",
  class: "renmixu",
  propsAsIs: false
});
export const ControlIcon = /*#__PURE__*/styled('div')({
  name: "ControlIcon",
  class: "cvromqn",
  propsAsIs: false
});
export const ControlInput = /*#__PURE__*/styled('input')({
  name: "ControlInput",
  class: "caue1a9",
  propsAsIs: false
});
interface LabelProps {
  hasTouchArea: boolean;
  fullWidth: boolean;
  htmlFor: string;
}
export const ControlWithCheckmark = ({
  checked,
  value,
  name,
  dataId,
  onChange,
  label,
  disabled,
  fullWidth = false,
  hasError = false,
  hasTouchArea = false,
  type = 'radio',
  className
}: Props) => {
  const disabledChecked = checked && disabled;
  return <ControlElement className={className}>
      <ControlBody hasTouchArea={hasTouchArea} fullWidth={fullWidth} htmlFor={value}>
        <ControlInput type={type} name={name} id={value} data-id={dataId} checked={checked} value={value} disabled={disabled} data-field-error={hasError} onChange={onChange} />
        <ControlIcon className={cx(disabledChecked && 'disabledChecked')}>
          {(checked && !hasError || disabledChecked) && <Icon name="Checkmark" size="sm" colorPath={disabledChecked ? 'content.neutral.c500' : 'content.neutral.c000'} />}
        </ControlIcon>
        {Boolean(label) && <RadioContentWrapper className="radio-content">
            <Text className="radio-content-text" variant="bodyS" as="span">
              {label}
            </Text>
          </RadioContentWrapper>}
      </ControlBody>
    </ControlElement>;
};

require("./ControlWithCheckmark.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./ControlWithCheckmark.tsx");